document.addEventListener('DOMContentLoaded', function () {
  const accordionTriggers = document.querySelectorAll('.accordion__trigger');

  accordionTriggers.forEach(trigger => {
    trigger.addEventListener('click', function () {
      const accordionItem = this.closest('.accordion__item');

      // Check if this accordion is already open
      const isOpen = accordionItem.classList.contains('accordion-open');

      // Toggle the accordion-open class
      accordionItem.classList.toggle('accordion-open');
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var submitButton = document.querySelector('[id^="gform_submit_button_"]');

  // Gravity Forms 3 renders the submit as a <button>. Keep the element (its
  // type="submit" and onclick drive the submission) and wrap the label in the
  // CTA text span the theme's button styles target.
  if (submitButton && submitButton.tagName === 'BUTTON' && !submitButton.querySelector('.cta-button__text')) {
    var label = submitButton.textContent.trim();

    var labelSpan = document.createElement('span');
    labelSpan.className = 'cta-button__text';
    labelSpan.setAttribute('data-text', label);
    labelSpan.textContent = label;

    submitButton.textContent = '';
    submitButton.appendChild(labelSpan);
    return;
  }

  if (submitButton && submitButton.tagName === 'INPUT' && submitButton.type === 'submit') {
    var buttonText = submitButton.value.trim();

    var newButton = document.createElement('a');
    newButton.id = submitButton.id;
    newButton.className = submitButton.className;
    newButton.setAttribute('role', 'button');

    if (submitButton.hasAttribute('onclick')) {
      newButton.setAttribute('onclick', submitButton.getAttribute('onclick'));
    }

    var textSpan = document.createElement('span');
    textSpan.className = 'cta-button__text';
    textSpan.setAttribute('data-text', buttonText);
    textSpan.textContent = buttonText;

    newButton.appendChild(textSpan);
    submitButton.parentNode.replaceChild(newButton, submitButton);
  }
});